import { useState, useCallback, useEffect, useMemo } from 'react';
import Layout from 'components/layouts';
import { useLocation } from 'react-router-dom';
import SettingsApi from 'libs/api/settings';
import PageTitle from 'components/organisms/PageTitle';
import FormFooter from 'components/molecules/FormFooter';
import SettingsMainFormLoader from 'components/atoms/Loaders/FormLoaders/SettingsMainForm';

import ServicesContent from 'components/organisms/settings/ServicesContent';
import TimesForm from 'components/molecules/settings/TimesForm';

import {
  StyledFormBlockWrapper,
  StyledMenuWrapper,
} from 'components/atoms/Wrappers';
import { Header, HeaderTitle } from 'components/organisms/SettingsForm/styled';
import { useSettings } from 'redux/settings/use-settings';
import { useCommon } from 'redux/common/use-common';
import { deliveryKeys, mainTabsKeys } from 'common/constants/settings';
import SetupSettings from '../../molecules/settings/v2/SetupSettings';
import { Divider, Title } from '../../atoms/styleds';
import TabSwitcher from 'components/molecules/TabSwitcher';
import RouterHelper from 'services/RouterHelper';
import routeCodes from 'common/constants/route-codes';
import Ipratico from 'components/organisms/settings/Ipratico';
import Modal from 'components/molecules/Modal';
import { useDynamicApi } from 'hooks/api/dynamic-api';
import IpraticoApi from 'libs/api/ipratico';

const getTab = (pathname) => {
  if (pathname.includes('configs')) {
    return mainTabsKeys.configs;
  }
  if (pathname.includes('time')) {
    return mainTabsKeys.times;
  }
};

const getConfigTab = (pathname) => {
  if (pathname.includes('delivery')) {
    return deliveryKeys.delivery;
  }
  return deliveryKeys.reservation;
};

export const SettingTabKeys = {
  main: 'main',
  ipratico: 'ipratico',
};

const SettingsMainLayout = ({
  children,
  onSubmitAction,
  onChange,
  setOpeningHourErrors,
  onSelectConfig,
  localState = {},
  changeDeliveryDayConfig,
  deliveryActiveTab,
  deliveryDates,
  fetchDeliveryDates,
  onChangeDeliveryTab,
  onChangeMaximum,
  onChangeExceptionDay,
  onAddExceptionData,
  isLoading,
  localUpdateInProcess,
  showFooter = true,
  isAutoSave = false,
  openingHourErrors,
  onCancel,
  onDeleteException,
  onAddNewException,
  exceptionErrors,
  isSuperAdmin,
  setDeliveryDates,
}) => {
  const { pathname } = useLocation();
  const [tabConfigured, setTabConfigured] = useState(false);
  const [mainActiveTab, setMainActiveTab] = useState(SettingTabKeys.main);
  const [dataForRequest, setDataForRequest] = useState({});
  const [deliveryZips, setDeliveryZips] = useState([]);
  const [ipraticoData, setIpraticoData] = useState({});
  const [ipraticoErrors, setIpraticoErrors] = useState(null);
  const [ipraticoInProcess, setIpraticoInProcess] = useState(false);
  const [needConfirm, setNeedConfirm] = useState(false);
  const [configTabKey, setConfigTabKey] = useState(getConfigTab(pathname));
  const [configChangeInProcess, setConfigChangeInProcess] = useState(false);

  const { api: ipraticoApi } = useDynamicApi(IpraticoApi);

  const {
    handleGetSettings,
    getInProcess,
    data,
    handleUpdate,
    updateInProcess,
  } = useSettings();
  const { currentRestaurant } = useCommon();

  const settingsApi = useMemo(() => {
    return new SettingsApi(currentRestaurant?.id);
  }, [currentRestaurant]);

  useEffect(() => {
    if (currentRestaurant?.id) {
      handleGetSettings();
    }
  }, [currentRestaurant?.id]);

  useEffect(() => {
    if (data) {
      setIpraticoData(s => ({
        ...s,
        ipratico_key: data?.ipratico_key,
        ipratico_service_charge_id: data?.ipratico_service_charge_id,
      }));
    }
  }, [data]);

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (onSubmitAction) {
        return onSubmitAction();
      }
      if (activeTab === mainTabsKeys.configs) {
        handleUpdate({
          settings: { ...dataForRequest, delivery_zips: deliveryZips },
        });
      }
      if (activeTab === mainTabsKeys.times) {
        // setLocalUpdateInProcess(true);
        try {
          await settingsApi.updateOpeningHours(
            deliveryActiveTab,
            deliveryDates[deliveryActiveTab],
          );
          const { data: newData } = await settingsApi.get(
            `opening_hours/${deliveryActiveTab}`,
          );
          setDeliveryDates((state) => ({
            ...state,
            [deliveryActiveTab]: {
              ...state[deliveryActiveTab],
              isFetched: true,
              errors: null,
              ...newData,
            },
          }));
          handleUpdate({
            settings: { ...dataForRequest, delivery_zips: deliveryZips },
          });
          // UIHelper.showSuccessNotification(successToastsKeys.settingsUpdate);
        } catch (e) {
          setHoursErrors(e?.response?.data?.opening_hours);
        } finally {
          // setLocalUpdateInProcess(false);
        }
      }
    },
    [
      dataForRequest,
      deliveryZips,
      deliveryDates,
      settingsApi,
      deliveryActiveTab,
      onSubmitAction,
    ],
  );

  const onChangeConfigTabKey = useCallback((tab) => {
    setConfigTabKey(tab);
  }, []);

  const [selectedValues, setSelectedValues] = useState([]);

  useEffect(() => {
    const selected = [];
    ['table_reservation', 'takeaway', 'delivery'].forEach((i) => {
      if (localState && localState[i]) {
        selected.push(i);
      }
    });
    setSelectedValues(selected);
  }, [localState]);

  const showMainContent = true;
  // localState &&
  // (localState.delivery ||
  //   localState.table_reservation ||
  //   localState.takeaway);

  const isIpratico = useMemo(() => {
    return !!data.ipratico_active;
  }, [data]);

  useEffect(() => {
    setTabConfigured(true);
    setMainActiveTab(
      isIpratico ? SettingTabKeys.ipratico : SettingTabKeys.main,
    );
  }, [isIpratico]);

  const onChangeConfigs = useCallback(async () => {
    setConfigChangeInProcess(true);
    try {
      await ipraticoApi.get('destroy_all');
      handleGetSettings();
      setNeedConfirm(false);
    } catch (e) {
      console.log('er', e);
    } finally {
      setConfigChangeInProcess(false);
    }
  }, [handleGetSettings, ipraticoApi]);

  const onChangeMainTab = useCallback((key) => {
    if (mainActiveTab !== key) {
      setNeedConfirm(true);
    }

  }, [mainActiveTab]);

  return (
    <Layout>
      <PageTitle />
      <StyledMenuWrapper style={{ flex: 1, flexDirection: 'column' }}>
        {!getInProcess ? (
          <StyledFormBlockWrapper
            as='form'
            // onSubmit={
            //   mainActiveTab === SettingTabKeys.ipratico
            //     ? onSubmitIpratico
            //     : onSubmit
            // }
            onSubmit={onSubmit}
            desktopMl={0}
            style={{
              minHeight: '100%',
              flexDirection: 'column',
              display: mainActiveTab === SettingTabKeys.main ? 'block' : 'flex',
            }}
          >
            <Header>
              <HeaderTitle>Impostazioni</HeaderTitle>
              {/*<TabSwitcher*/}
              {/*  activeKey={mainActiveTab}*/}
              {/*  onClick={onChangeMainTab}*/}
              {/*  items={[*/}
              {/*    {*/}
              {/*      id: SettingTabKeys.main,*/}
              {/*      label: 'Impostazioni',*/}
              {/*      to: isSuperAdmin*/}
              {/*        ? RouterHelper.getRouteWithRestaurant(*/}
              {/*            routeCodes.superAdmin.settings,*/}
              {/*          )*/}
              {/*        : routeCodes.settings,*/}
              {/*      name: SettingTabKeys.main,*/}
              {/*    },*/}
              {/*    {*/}
              {/*      id: SettingTabKeys.ipratico,*/}
              {/*      label: 'Ipratico',*/}
              {/*      to: isSuperAdmin*/}
              {/*        ? RouterHelper.getRouteWithRestaurant(*/}
              {/*            routeCodes.superAdmin.settingsIpratico,*/}
              {/*          )*/}
              {/*        : routeCodes.settingsIpratico,*/}
              {/*      name: SettingTabKeys.ipratico,*/}
              {/*    },*/}
              {/*  ]}*/}
              {/*  isLink={false}*/}
              {/*  maxW='315px'*/}
              {/*/>*/}
            </Header>
            <>
              <>
                <SetupSettings
                  selectedValues={selectedValues}
                  onAccept={onSelectConfig}
                  isAutoSave={isAutoSave}
                  dataForRequest={dataForRequest}
                />
                {showMainContent && (
                  <>
                    <Divider style={{ width: '100%' }} />
                    <TimesForm
                      data={data}
                      setOpeningHourErrors={setOpeningHourErrors}
                      changeDeliveryDayConfig={changeDeliveryDayConfig}
                      deliveryActiveTab={deliveryActiveTab}
                      deliveryDates={deliveryDates}
                      fetchDeliveryDates={fetchDeliveryDates}
                      onChangeDeliveryTab={onChangeDeliveryTab}
                      onChangeMaximum={onChangeMaximum}
                      onChangeExceptionDay={onChangeExceptionDay}
                      onAddExceptionData={onAddExceptionData}
                      deliveryLoading={isLoading}
                      openingHourErrors={openingHourErrors}
                      onDeleteException={onDeleteException}
                      onAddNewException={onAddNewException}
                      exceptionErrors={exceptionErrors}
                    />
                    <ServicesContent
                      currentRestaurant={currentRestaurant}
                      isSuperAdmin={isSuperAdmin}
                      data={localState}
                      onSelectConfig={onSelectConfig}
                      activeTabKey={configTabKey}
                      onChangeTab={onChangeConfigTabKey}
                      isAutoSave={isAutoSave}
                    />
                    {children}
                    <Divider style={{ width: '100%' }} />
                  </>
                )}
              </>
            </>
            {/*{needConfirm && (*/}
            {/*  <Modal*/}
            {/*    open={true}*/}
            {/*    onClose={() => setNeedConfirm(false)}*/}
            {/*    onCancel={() => setNeedConfirm(false)}*/}
            {/*    inProcess={configChangeInProcess}*/}
            {/*    body={*/}
            {/*      <Title>*/}
            {/*        Cambiando setup, tutte le impostazioni verranno cancellate!*/}
            {/*        Procedere?*/}
            {/*      </Title>*/}
            {/*    }*/}
            {/*    onSubmit={onChangeConfigs}*/}
            {/*    actionButtonText='Si'*/}
            {/*    cancelButtonText='No'*/}
            {/*  />*/}
            {/*)}*/}
            {showFooter && (
              <FormFooter
                mobPadding='20px'
                style={{ marginTop: 0 }}
                isForm={true}
                inProcess={
                  updateInProcess || localUpdateInProcess || ipraticoInProcess
                }
                onCancel={onCancel}
              />
            )}
          </StyledFormBlockWrapper>
        ) : (
          <SettingsMainFormLoader />
        )}
      </StyledMenuWrapper>
    </Layout>
  );
};

export default SettingsMainLayout;
